// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JazX","placeholdersHeader":"styles_placeholdersHeader__1PXYz","editorStyle":"styles_editorStyle__oI1xr","placeholdersBox":"styles_placeholdersBox__fARXT"};